import {
  faChevronDown,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'
import { Button, ButtonActionProps } from '../Button'
import { Menu } from './Menu'
import { useIsMobile } from '../../hooks'
import { Modal } from '../Modal'
import { createContext, useContext, useRef, useState } from 'react'

const ButtonMenuContext = createContext<{ close: () => void }>({
  close: () => {},
})
export const useButtonMenu = () => useContext(ButtonMenuContext)

/**
 *  Really simple component for a button with a popup menu
 */
export const ButtonMenu = ({
  children,
  buttonText,
  closeOnMenuClick,
  label,
  icon,
  ...props
}: {
  buttonText?: React.ReactNode
  closeOnMenuClick?: boolean
  label?: string
  icon?: IconDefinition
} & Omit<ButtonActionProps, 'onClick' | 'ref'>) => {
  const ref = useRef<HTMLButtonElement>(null)
  const isMobile = useIsMobile()
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)
  return (
    <>
      <Button
        icon={icon || faChevronDown}
        iconPosition='right'
        onClick={() => setOpen(true)}
        ref={ref}
        {...props}>
        {buttonText}
      </Button>
      <ButtonMenuContext.Provider value={{ close }}>
        {!isMobile ? (
          <Menu isOpen={open} onClose={close} triggerRef={ref}>
            <div onClick={() => closeOnMenuClick && close()}>
              {children}
            </div>
          </Menu>
        ) : (
          <Modal
            isOpen={open}
            onClose={close}
            title={label || buttonText}
            type='modal'>
            <div
              className='p-4'
              onClick={() => closeOnMenuClick && close()}>
              {children}
            </div>
          </Modal>
        )}
      </ButtonMenuContext.Provider>
    </>
  )
}
